export default __webpack_public_path__ + "static/media/dmtechtree.36493946.png";